import React from "react";
import cn from "@/hooks/class-names";
import CustomText from "@/components/ui/text/custom-text";
import LanguageSwitcher from "@/components/language/language-switcher";
import useDynamicTranslation from "@/hooks/use-universal-transalation";
import { Facebook, Linkedin, Youtube } from "lucide-react";
import Link from "next/link";

// Inline X icon component
function XIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 1200 1227"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M714.6 564.8L1159.9 0H1052.7L667.8 483.7L362.4 0H0L473.3 723.6L0 1227H107.2L518.5 712.5L837.7 1227H1200L714.6 564.8Z" />
    </svg>
  );
}

export default function TopBar() {
  const { getTranslated } = useDynamicTranslation(["topbar"]);

  const SocailLinks = [
    { icon: <XIcon className="w-4 h-4" />, url: "https://x.com/nicdc01" },
    {
      icon: <Facebook className="w-5 h-5" />,
      url: "https://www.facebook.com/NICDC01",
    },
    {
      icon: <Linkedin className="w-5 h-5" />,
      url: "https://www.linkedin.com/company/nicdc/",
    },
    {
      icon: <Youtube className="w-5 h-5" />,
      url: "https://www.youtube.com/c/NICDC",
    },
  ];

  return (
    <div className={cn("bg-gray p-3 lg:px-20")}>
      <div className="flex justify-between">
        <div className="flex">
          <ul className="flex space-x-2 items-center">
            {SocailLinks.map((ele, index) => (
              <li key={index}>
                <Link href={ele.url} target="_blank">
                  {ele.icon}
                </Link>
              </li>
            ))}
          </ul>
          <div className="ml-4">
            <a href="/open-vc-link" legacyBehavior target="_blank">
              <CustomText
                text={getTranslated("notice", "topbar")}
                className="text-orange font-semibold tracking-wide text-base cursor-pointer"
              />
            </a>
          </div>
        </div>

        <LanguageSwitcher />
      </div>
    </div>
  );
}
